import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ErrorActions, ErrorActionTypes } from './error.actions';

export const STORE_FEATURE_NAME = 'Error';

export interface State {
  handled: boolean;
}

const initialState: State = {
  handled: false,
};

export function reducer(state = initialState, action: ErrorActions): State {
  switch (action.type) {
    case ErrorActionTypes.AuthorisationErrorOccurred:
    case ErrorActionTypes.NotFoundErrorOccurred:
    case ErrorActionTypes.ParamsNotValidErrorOccurred:
    case ErrorActionTypes.HttpExceptionErrorOccurred:
    case ErrorActionTypes.UnhandledExceptionErrorOccurred:
    case ErrorActionTypes.SessionExpiredErrorOccurred:
    default:
      return state;
  }
}

export const selectErrorState = createFeatureSelector<State>(
  STORE_FEATURE_NAME
);

export const selectHandled = createSelector(
  selectErrorState,
  state => state.handled
);
